import logo from "./logo.svg";
import "./App.css";
// import "./style.css";
import SideBar from "./SideBar";
import Banner from "./Banner";
import About from "./About";
import ToggleButton from "./ToggleButton";
function App() {
  return (
    <>
      <ToggleButton />
      <SideBar />
      <Banner />
      <About />
    </>
  );
}

export default App;
